import React from "react";
import {Avatar} from "antd";
import {RocketOutlined} from "@ant-design/icons";

import './styles.scss';
import {IUser} from "../../../api/User/User.types";

interface Props {
    user: IUser
}

function UserPicture(props: Props) {
    const { user } = props;
    return (
        <div>
            {user?.picture && <Avatar size={30} icon={<img alt={user?.email} src={user?.picture}/>}/>}
            {!user?.picture &&
            <Avatar style={{backgroundColor: '#16c784'}}
                    size={40} icon={<RocketOutlined/>}/>}
        </div>
    )
}

export default UserPicture;